module.exports = __webpack_public_path__ + "static/img/3_3.717d4057.jpg";